import CalendarEventsView from './CalendarEventsView';
import CalendarHeader from './CalendarHeader';
import useCalendarViewState from '../hooks/useCalendarViewState';
import type { CalendarPayload } from '../schema';
import { observer } from 'mobx-react-lite';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import * as React from 'react';
import { useAssetPerfDatapoint } from 'owa-timestream-asset-sdk';

export default observer(function CalendarView(props: AssetCommonViewProps<CalendarPayload>) {
    const assetPerfDatapoint = useAssetPerfDatapoint();
    const {
        calendarIds,
        viewType,
        isLoaded,
        onSelectCalendar,
        selectedDate,
        scenarioId,
        onDateUpdated,
        numDaysInDayView,
        title,
        onChangeTitle,
    } = useCalendarViewState(props, assetPerfDatapoint);
    return (
        <>
            <CalendarHeader
                isNewlyCreated={props.isNewlyCreated}
                isDragPreview={props.isDragPreview}
                calendarIds={calendarIds}
                viewType={viewType}
                isLoaded={isLoaded}
                scenarioId={scenarioId}
                onSelectCalendar={onSelectCalendar}
                title={title}
                onChangeTitle={onChangeTitle}
            />
            {viewType !== undefined && isLoaded && (
                <CalendarEventsView
                    viewType={viewType}
                    scenarioId={scenarioId}
                    calendarIds={calendarIds}
                    selectedDate={selectedDate}
                    onDateUpdated={onDateUpdated}
                    numDaysInDayView={numDaysInDayView}
                    assetPerfDatapoint={assetPerfDatapoint}
                />
            )}
        </>
    );
});
